

const animators = [
  
  {
    path: 'animators',
    component: () => import(/* webpackChunkName: "animation" */ '@/views/animation/AnimatorsContainer.vue'),
    children: [
      {
        path: '/:lang?/animation-commissioning',
        name: 'commissioning animation',
        component: () => import(/* webpackChunkName: "animation" */ '@/views/animation/CommissioningAnimation.vue')
      },
      
      {
        path: '/:lang?/animators/:name',
        name: 'animation portfolio',
        component: () => import(/* webpackChunkName: "animation" */ '@/views/animation/AnimationPortfolio.vue'),
        props: true
      },
      {
        path: '/:lang?/animators/:name/styles/animation/:galname',
        name: 'animator style selection',
        component: () => import(/* webpackChunkName: "animation" */ '@/views/animation/AnimationPortfolio.vue'),
        props: true
      },
      {
        path: '/:lang?/animators',
        name: 'All Animators',
        component: () => import(/* webpackChunkName: "animation" */ '@/views/animation/AllAnimators.vue')
      },
      {
        path: '/:lang?/animators/:name/:imageid',
        name: 'uni Single Animation View',
        component: () => import(/* webpackChunkName: "seo" */ '@/views/illustration/ImagePage.vue'),
        props: true
      }
    ]
  },
  {
    path: '/:lang?/animation',
    name: 'animators home page',
    component: () => import(/* webpackChunkName: "animation" */ '@/views/animation/HomePage.vue')
  },
  {
    path: '/:lang?/styles/animation/:url',
    name: 'animation style gallery',
    component: () => import(/* webpackChunkName: "animation" */ '@/views/animation/StyleGallery.vue'),
    props: true
  },
  
]

export default animators